import '../scss/qhomewidget.scss';
"use-strict"
//import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

$(document).ready(function() {

    actionsScroll();
    $(window).on('scroll', function(){    
        actionsScroll();
    });

    if ($('.collection-text').length) {
        var text = $('.collection-text').text();
            text = text.replace('%yellow_start', '<span class="yellow-text">')
            text = text.replace('%yellow_end', '</span>');

        $('.collection-text').html(text);
    }

    if ($('.lookbook-text').length) {
        var text = $('.lookbook-text').text();
            text = text.replace('%yellow_start', '<span class="yellow-text">')
            text = text.replace('%yellow_end', '</span>');

        $('.lookbook-text').html(text);
    }

    imgBack();

    $('#iqitmegamenu-mobile .cbp-mobilesubmenu').css('width', $(window).innerWidth());

    $(window).on('resize', function(){
        $('#iqitmegamenu-mobile .cbp-mobilesubmenu').css('width', $(window).innerWidth());
    });

    if( $("#index").length != 0 ){
        animationScroll();
        //$('.headerSpace').remove();
    }

    $(".display_nav .footer_block ul li a").append('<i class="fa-solid fa-messages"></i>');

    $(".flex--lookbook .owl-carousel").owlCarousel({
        pagination: false,
        margin:9,
        loop: true,
        autoplay: true,
        autoPlayTimeout: 0,
        autoPlaySpeed: 3000,
        rtl: true,
        items : 3,
        dots: false,
        responsive:{
            0:{
                items:2,
            },
            600:{
                items:2,
            }
        }
    });
});

function imgBack(){

    if ($('.backImg').length) {
        $('.backImg').each(function(){
            var urlImgCurrent = $(this).children('img').attr('src');
            if (urlImgCurrent && urlImgCurrent != undefined && $(this).children('img').length) {
                $(this).attr('style', 'background-image:url('+urlImgCurrent+'); background-position: 50% 50%; background-size: cover; background-repeat: no-repeat;background-color:white;');
                $(this).find('img').hide();			
            }
        });
    }
}

function actionsScroll(){

    $('.site-search').removeClass('active');

    var scrolled = $(window).scrollTop();

    if(scrolled > 0 ){
        if (!$('body').hasClass('scrolling')) {
            $('body').addClass('scrolling');
        }
    } else {
        if ($('body').hasClass('scrolling')) {
            $('body').removeClass('scrolling');
        }
    }

    if( scrolled > $('#header').innerHeight() - $('#iqitmegamenu-horizontal').innerHeight()){
        if (!$('#header').hasClass('scroll-menu')) {
            $('#header').addClass('scroll-menu');
        }
        
    } else if (scrolled < $('#header').innerHeight() - $('#iqitmegamenu-horizontal').innerHeight()){
        if ($('#header').hasClass('scroll-menu')) {
            $('#header').removeClass('scroll-menu');
        }
    }

    if(scrolled > $('.header-content').innerHeight() * 0.5 ){

        if (!$('.header-content').hasClass('scroll-menu--under')) {
            $('.header-content').addClass('scroll-menu--under');
        }
    } else {
        if ($('.header-content').hasClass('scroll-menu--under')) {
            $('.header-content').removeClass('scroll-menu--under');
        }
    }
}

function animationScroll(){

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.defaults({
        toggleActions: "restart pause resume pause"
    });
    
    // NEWS
    if( $(window).innerWidth() > 1000 ){

        var heightScroll = -$(".section--news .products--col-1").innerHeight() + ($(window).innerHeight()*0.75);
        var heightScroll2 = $(".section--news .products--col-2").innerHeight() - ($(window).innerHeight()*0.75);
        var scrollNumber = $(".section--news .products--col-1 .product").length;
        var scrollLevel = ($(".section--news .products--scrollbar .scroll-timeline").innerHeight() - $(".section--news .products--scrollbar .scroll-bar").innerHeight()) / scrollNumber;

        gsap.to(".section--news", {
            scrollTrigger:{
                trigger: ".section--news",
                start: "top top",
                scrub: true,
                pin: true,
                //pinSpacing: false
            }
        });

        gsap.to(".section--news .products--col-1", {
            scrollTrigger:{
                trigger: ".section--news",
                start: "top top",
                scrub: true
            },
            y: heightScroll
        });

        gsap.to(".section--news .products--col-2", {
            scrollTrigger:{
                trigger: ".section--news",
                start: "top top",
                scrub: true
            },
            y: heightScroll2
        });

        gsap.to(".section--news .products--scrollbar .scroll-bar", {
            scrollTrigger:{
                trigger: ".section--news",
                start: "top top",
                scrub: true
            },
            y: scrollLevel * scrollNumber
        });

        var num = {var:1};
        gsap.timeline({
            scrollTrigger:{
                trigger: ".section--news",
                start: "top top",
                scrub: true
            },
        }).to(num, {var:scrollNumber, onUpdate:changeNumber});

        function changeNumber() {
            qnews_scroll_min.innerHTML = "0"+Math.trunc(num.var);
        }
    }

    // POPULAIRES
    // if( $(window).innerWidth() > 1000){

    //     var _heightScroll = -$('.section--populaires .products').innerHeight()*0.5;
    //     var _scrollNumber = $(".section--populaires .products .product").length;
    //     var _scrollLevel = ($(".section--populaires .products--scrollbar .scroll-timeline").innerHeight() - $(".section--populaires .products--scrollbar .scroll-bar").innerHeight()) / scrollNumber;

    //     //$(".section--populaires .products--scrollbar .number-bottom").innerHTML = "0"+Math.round(_scrollNumber / 4);

    //     gsap.to(".section--populaires", {
    //         scrollTrigger:{
    //             trigger: ".section--populaires",
    //             scrub: true,
    //             pin: true,
    //             //pinSpacing: false
    //         }
    //     });

    //     gsap.to(".section--populaires .products", {
    //         scrollTrigger:{
    //             trigger: ".section--populaires",
    //             start: "top 70px",
    //             scrub: true
    //         },
    //         y: _heightScroll
    //     });

    //     gsap.to(".section--populaires .products--scrollbar .scroll-bar", {
    //         scrollTrigger:{
    //             trigger: ".section--populaires",
    //             start: "top 70px",
    //             scrub: true
    //         },
    //         y: _scrollLevel * Math.round(_scrollNumber / 4)
    //     });
    // }
}